const PageTitle = ({ title }) => {
  return (
    <div className="mb-5 flex flex-col sm:flex-row items-center justify-between">
      <h3 className="text-text-1/80 font-bold text-xl sm:text-xl text-center sm:text-left">
        {title}
      </h3>
      <div></div>
    </div>
  );
};

export default PageTitle;
